import { Role } from "@/models/role/role.model"
import type { IRoleFinancialOfficer } from "@/interfaces/api/role/role-financial-officer.interface"
import { RoleTypes } from "@/enums/role-types"

export class RoleFinancialOfficer extends Role implements IRoleFinancialOfficer {
  public static className = "RoleFinancialOfficer"
  public static verboseName = "Financieel verantwoordelijke"

  emails: string

  constructor(roleFinancialOfficer: IRoleFinancialOfficer) {
    super(roleFinancialOfficer)

    this.type = RoleTypes.FINANCIAL_OFFICER

    this.emails = roleFinancialOfficer.emails ?? ""
  }

  public getEmails(): string[] {
    return this.emails?.split(";") ?? []
  }
}
